// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1vGIK","alert":"SettungsInbox_alert__3xvek"};